import {JsonObject, JsonProperty} from 'json2typescript';

@JsonObject('FileToDownload')
export class FileToDownload {

  @JsonProperty('src',String)
  src = '';

  @JsonProperty('size',Number)
  size = 0;

  @JsonProperty('unit',String)
  unit = '';

  @JsonProperty('lastModifiedDate',Number)
  timestamp = 0;

 /* @JsonProperty('mainFile',Boolean,true)
  mainFile=false;*/

  @JsonProperty('type',String,true)
  type = ''; // ui_file, config this variable is not used

  associatedTerminalName:string; // this variable is exclusively used for the file chooser; an eventual refactorisation to create a common interface is due.

    constructor() {
      /*this.src = json.src;
      this.size = json.size;
      this.unit = json.unit;
      this.timestamp = json.timestamp;
      this.mainFile = json.mainFile;*/

    }

}
